import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Save, DollarSign } from 'lucide-react';

const CurrencySettings = () => {
  const [rate, setRate] = useState('');
  const [baseCurrency, setBaseCurrency] = useState('UGX');
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => { fetchSettings(); }, []);
  const fetchSettings = async () => {
    try {
      const r = await api.get('/config/currency');
      setRate(r.data?.usd_to_ugx_rate ?? 1);
      setBaseCurrency(r.data?.base_currency || 'UGX');
      setUpdatedAt(r.data?.updated_at || null);
    } catch (e) { console.error(e); } finally { setLoading(false); }
  };

  const save = async (e) => {
    e.preventDefault();
    if (!rate || Number(rate) <= 0) { alert('Enter a valid exchange rate'); return; }
    setSaving(true);
    try {
      const r = await api.put('/config/currency', { usd_to_ugx_rate: Number(rate), base_currency: baseCurrency });
      setUpdatedAt(r.data?.updated_at || null);
      alert('Currency settings saved.');
    } catch (err) { alert(err.response?.data?.detail || 'Failed to save'); }
    finally { setSaving(false); }
  };

  return (
    <div data-testid="currency-settings-page">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 style={{ fontSize: '24px', fontWeight: 700, margin: 0 }}>Currency Settings</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-tertiary)', fontSize: '13px' }}>Base currency is UGX. Set the USD exchange rate used when an order is priced in USD.</p>
        </div>
      </div>

      <div className="card" style={{ maxWidth: '480px' }}>
        {loading ? <div>Loading...</div> : (
          <form onSubmit={save}>
            <div className="form-group">
              <label className="form-label">Base Currency</label>
              <input type="text" className="form-input" value={baseCurrency} readOnly style={{ background: 'var(--bg-secondary)' }} data-testid="base-currency-input" />
            </div>
            <div className="form-group">
              <label className="form-label">Exchange Rate — 1 USD = ? {baseCurrency}</label>
              <div style={{ position: 'relative' }}>
                <DollarSign size={16} style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-tertiary)' }} />
                <input type="number" step="0.0001" className="form-input" value={rate} onChange={(e) => setRate(e.target.value)} style={{ paddingLeft: '36px' }} placeholder="e.g. 3800" data-testid="rate-input" />
              </div>
              <div style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginTop: '6px' }}>
                Example: 1 USD = {rate || '—'} {baseCurrency}. When a Sales/Purchase order selects USD, prices and totals convert using this rate.
              </div>
            </div>
            {updatedAt && <div style={{ fontSize: '12px', color: 'var(--text-tertiary)', marginBottom: '12px' }}>Last updated: {new Date(updatedAt).toLocaleString()}</div>}
            <button type="submit" className="btn btn-primary" disabled={saving} data-testid="save-currency-btn"><Save size={16} /> {saving ? 'Saving...' : 'Save Settings'}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default CurrencySettings;
